import React, { useCallback } from 'react';
import * as Yup from 'yup';
import ZipCodeInput, { ZipCodeInputInitialValues, ZipCodeInputSchemaFields } from '../../../components/form-fragments/ZipCodeInput';

const validationSchema = Yup.object().shape({
    ...ZipCodeInputSchemaFields,
});

function InactiveChildren({ values }) {
    return (
        <>
            {values.zipCode && (
                <dl className="uk-description-list">
                    <dt>Ihre Postleitzahl:</dt>
                    <dd>{values.zipCode}</dd>
                </dl>
            )}
        </>
    );
}

function ActiveChildren({ values, setFieldValue, handleBlur, touched, errors }) {
    const onChange = useCallback(({ name, value }) => setFieldValue(name, value), [setFieldValue]);

    return <ZipCodeInput values={values} onChange={onChange} onBlur={handleBlur} errors={errors} touched={touched} />;
}

export const zipCodeStepFactory = ({ markenStandortId }) => {
    return {
        inactiveChildren: props => <InactiveChildren {...props} />,
        activeChildren: props => <ActiveChildren {...props} />,
        title: 'Standortauswahl',
        initialValues: { ...ZipCodeInputInitialValues(), selectedSublocation: markenStandortId },
        validationSchema,
    };
};
